import React, {useContext, useState, useEffect} from 'react'
import axiosInstance from '../utils/RequestsQueue';
import { AuthContext } from '../auth/AuthContext';
import { sortContacts } from './ContactUtils';


export const ContactContext = React.createContext();
export default function ContactProvider({ children }) {

    const {authToken, currentUser} = useContext(AuthContext)
    const [loading, setLoading] = useState(false)
    const [contacts, setContacts] = useState([])




  
  // SUBMIT CONTACT US FORM  

    async function submitContactForm(formData){
      // if (!!authToken){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/contact/submit`,
                method:"POST",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  // Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
             
              return response?.data
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              return error?.response?.data
          } finally {
              setLoading(false)
          }
      // }
    }


  // GET ALL CONTACT US DATA  
      async function fetchAllContacts(){
        if (!!authToken && !!currentUser && currentUser.role === 'support'){
            setLoading(true)
            // console.log('Submited password:',password)
            try {
                const response = await axiosInstance.requestWithQueue({
                  url: `${process.env.REACT_APP_SERVER_URL}/contact/all`,
                  method:"GET",
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`
                  },
                  // data:formData
                })
                // console.log('Response:',response?.data)
                setContacts(sortContacts(response?.data?.data)) 
      
            } catch (error){
                // console.log('Error Response:',error?.response?.data)
                console.error(error?.response?.data)
            } finally {
                setLoading(false)
            }
          }
        }
      
  
        useEffect(() => {
          // Fetch once immediately
          fetchAllContacts();
        
          // Set interval to fetch every 5 minutes (300,000 ms)
          const intervalId = setInterval(() => {
            fetchAllContacts();
          }, 5 * 60 * 1000); // 5 minutes
        
          // Cleanup on unmount
          return () => clearInterval(intervalId);
        }, [currentUser]);
          
    


  // UPDATE CONTACT US TO HANDLED 

    async function contactHandled(contactId){
        if (!!authToken && !!currentUser && currentUser.role === 'support'){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/contact/${contactId}/handle`,
                method:"POST",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                // data:formData
              })
              if (response?.data?.status === 'success'){
                fetchAllContacts()
              }
             
              return response?.data
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              return error?.response?.data
          } finally {
              setLoading(false)
          }
      }
    }



  const contextData = {
    loading, setLoading,
    contacts, setContacts,
    submitContactForm,
    contactHandled,
  }
  return (
    <ContactContext.Provider value={contextData}>
      {children}
    </ContactContext.Provider>
  
  )
}
